module.exports = __webpack_public_path__ + "img/vko2.c58cb27b.jpg";